/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit GetHelp.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-500.js"
import * as fromFlow from 'Logic/ViewsFlow.js'
import AskForHelp from './AskForHelp/logic.js'
import HelpMessageReceived from './HelpMessageReceived/logic.js'
import LogoDDCArrows from 'DesignSystem/Svgs/LogoDDCArrows/view.js'
import React from 'react'
import useIsMedia from 'Logic/useIsMedia.js'
import { css } from "emotion"
AskForHelp.displayName = 'AskForHelpLogic'
HelpMessageReceived.displayName = 'HelpMessageReceivedLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
alignItems: "center",
justifyContent: "center",
backgroundColor: "rgba(0, 188, 112,0.1)"})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
alignItems: "center",
opacity: 0.8,
  marginBottom: 'var(--marginBottom)',
marginTop: 'var(--marginTop)'})
styles.Text = css({label: 'Text',
  color: "#00BC70",
fontFamily: "WonderUnitSans",
fontSize: 28,
fontWeight: 500,
letterSpacing: 0.3})
styles.Vertical1 = css({label: 'Vertical1',
  backgroundColor: "white",
borderBottomLeftRadius: 16,
borderBottomRightRadius: 16,
borderTopLeftRadius: 16,
borderTopRightRadius: 16,
boxShadow: "0px 10px 20px 0px rgba(0, 188, 112, 0.2)",
  paddingTop: 'var(--paddingTop)',
paddingBottom: 'var(--paddingBottom)',
paddingLeft: 'var(--paddingLeft)',
paddingRight: 'var(--paddingRight)',
width: 'var(--width)'})

export default function GetHelp({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/Auth/GetHelp"
}) {
    
    
    let isMedia = useIsMedia()
    let flow = fromFlow.useFlow()
    
    

  return (<React.Fragment
>
<div
 data-testid="GetHelp.Vertical"
 data-view-path="/App/Auth/GetHelp"
 className={`views-block ${styles.Vertical}`}
>
<div
 data-testid="GetHelp.Horizontal"
 data-view-path="/App/Auth/GetHelp"
 style={{'--marginBottom': isMedia.mobile ? "20px" : "30px",'--marginTop': isMedia.mobile ? "20px" : "20px"}}
 className={`views-block ${styles.Horizontal}`}
>
<LogoDDCArrows
 data-testid="GetHelp.LogoDDCArrows"
 data-view-path="/App/Auth/GetHelp"
viewPath={`${viewPath}/LogoDDCArrows`}
 width={26}
 height={26}
 marginRight={6}
 marginBottom={4}
 fill="#00BC70"
/>
<span
 data-testid="GetHelp.Text"
 data-view-path="/App/Auth/GetHelp"
 className={`views-text ${styles.Text}`}
>
Direct Dental Care
</span>
</div>
<div
 data-testid="GetHelp.Vertical:1"
 data-view-path="/App/Auth/GetHelp"
 style={{'--paddingLeft': isMedia.mobile ? "20px" : "50px",'--paddingRight': isMedia.mobile ? "20px" : "50px",'--paddingBottom': isMedia.mobile ? "20px" : "50px",'--paddingTop': isMedia.mobile ? "30px" : "50px",'--width': isMedia.mobile ? "90%" : "450px"}}
 className={`views-block ${styles.Vertical1}`}
>
{flow.has(`${viewPath}/AskForHelp`) ? 
<AskForHelp
 data-testid="GetHelp.AskForHelp"
 data-view-path="/App/Auth/GetHelp"
viewPath={`${viewPath}/AskForHelp`}
/>
 : null
}
{flow.has(`${viewPath}/HelpMessageReceived`) ? 
<HelpMessageReceived
 data-testid="GetHelp.HelpMessageReceived"
 data-view-path="/App/Auth/GetHelp"
viewPath={`${viewPath}/HelpMessageReceived`}
/>
 : null
}
</div>
</div>
{children}
</React.Fragment>)
}